import { inView, animate } from "motion";

window.addEventListener("DOMContentLoaded", () => {
  function StickyScrollSidebar() {

    // IDENTIFY ELEMENTS =======================================
    const sectionPin = document.querySelector("[motion-online-rewards-wrapper]");
    if ( sectionPin ) {
      const carouselContent = sectionPin.querySelector("[motion-carousel-content]");
      const contentWrap = sectionPin.querySelector("[motion-content-wrap]");
      const cards = carouselContent.querySelectorAll("[motion-card]");
      const isWideEnough = window.innerWidth > 991;

      if (carouselContent && contentWrap && cards) {
        // PINNED CONTENT WITH SCROLLING SIDEBAR ===================
        // First, check if animations are enabled and the browser width is wide enough
        if (animationsEnabled && isWideEnough) {

          // LOCK CASINO BENEFITS SECTION TO VIEWPORT ==============
          // Set styles only needed for animation/pinning
          carouselContent.style.cssText = `padding-top: 200%; padding-bottom: 80%;`;
          sectionPin.style.cssText = `margin-top: -50%; position: relative; z-index: 0;`;
          contentWrap.style.cssText = `position: sticky; top: 0px; height: 100vh; display: flex; justify-content: center; align-items: center;`;

          // Add gradient masks to contentWrap
          // Get width of carousel margins and add 12px to account for borders or drop shadows
          const carouselWidth = carouselContent.offsetWidth + 12,
                sharedStyles = `left: 0; height: 40px; width: calc(100% + ${carouselWidth}px);`;
          contentWrap.innerHTML += `<div style="${sharedStyles} background: linear-gradient(180deg, var(--bs-body-bg) 0%, rgba(255, 255, 255, 0) 100%); top: 0;"></div><div style="${sharedStyles} background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, var(--bs-body-bg) 100%); bottom: 0;"></div>`;

          // Set negative margin-top to contentWrap to account for sticky positioning
          // and how it impacts the vertical spacing of section elements
          const adjustNegativeTopOffset = () => contentWrap.style.marginTop = `-${window.innerHeight}px`;
          adjustNegativeTopOffset();

          // ANIMATE CARDS =========================================
          cards.forEach((card, idx) => {
            // const rotate_in_from = [-4, 4];
            // const rotate_start = rotate_in_from[idx % 2];
            inView(card, () => {
              let controls = animate(card, { opacity: [0,1], scale: [0.8, 1] }, { duration: 0.5, ease: "easeInOut" });
              return (leaveInfo) => controls.stop(); // repeat animation each time card is scrolled into view
            });
          }, { amount: "all" });
          // -------------------------------------------------------

        } else {

          // RESET STYLES =========================================
          const resets = [carouselContent, sectionPin, contentWrap];
          resets.forEach(reset => reset.style.cssText = ``);
          // remove js-opacity-0 from cards
          cards.forEach(card => {
            card.classList.remove("js-opacity-0");
            card.style.cssText = ``;
          });
          // -------------------------------------------------------

        } // end (animationsEnabled && isWideEnough)
      }
    }
  } // end StickyScrollSidebar()

  /* On load   */ StickyScrollSidebar();
  /* On resize */ window.addEventListener("resize", () => StickyScrollSidebar());

}); // end DOMContentLoaded
